require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-meet-izzy-a-code-fellows-graduate.json") })
        }
      }, "path---blog-meet-izzy-a-code-fellows-graduate");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-meet-izzy-a-code-fellows-graduate!./.cache/json/blog-meet-izzy-a-code-fellows-graduate.json
// module id = 959
// module chunks = 231608221292675